import React from 'react';
import logo from '../../assets/logo_frame.png';

function Header() {

  return (
    <div className="header py-1 px-2 flex justify-center items-center">
      <img src={logo} alt="BWF logo" className="h-36 w-auto" />
    </div>
  );
}

export default Header;
